module.exports = __webpack_public_path__ + "static/img/smartProduct11.31631ea7.png";